import { Dialog, DialogPanel } from "@headlessui/react";
import { X } from "react-bootstrap-icons";

export const Overlay = ({ isOpen, title, onClose, action, children }) => {

  return (
    <Dialog open={isOpen} onClose={onClose} className="relative z-40">
      <div className="fixed inset-0 overflow-hidden">
        <div className="absolute inset-0 overflow-hidden">
          <div className={`pointer-events-none fixed inset-y-0 right-0 flex w-screen`}>
            <DialogPanel
              className={`pointer-events-auto w-full `}
            >
              <div className="h-full w-full flex flex-col items-center bg-white shadow-xl overflow-y-auto">
                <div className="flex w-full bg-white items-center py-5 px-2 border-b border-zinc-100 sticky top-0">
                  <button
                    type="button"
                    onClick={onClose}
                    className="rounded-md z-30 bg-white text-zinc-400 hover:text-zinc-500 cursor-pointer"
                  >
                    <span className="sr-only">Close panel</span>
                    <X aria-hidden="true" className="size-6" />
                  </button>
                  <h3 className="ml-2 text-base font-semibold">{title}</h3>
                  {action && (
                    <button
                      type="button"
                      onClick={action.onClick}
                      className="ml-auto mr-2 flex flex-col items-end gap-2 text-xs underline cursor-pointer"
                    >
                      {action.icon}
                      {action.label}
                    </button>
                  )}
                </div>
                <div className="grow w-full">{children}</div>
              </div>
            </DialogPanel>
          </div>
        </div>
      </div>
    </Dialog>
  );
}
